import React from 'react';
import {
  CheckCircle2,
  Clock,
  BookOpen,
  Archive,
} from 'lucide-react';

export interface EditionTypeStyle {
  label: string;
  badge: string;
  border: string;
  bg: string;
}

export const EDITION_TYPE_STYLES: Record<string, EditionTypeStyle> = {
  orisinal: {
    label: 'Edisi Pertama / Orisinal',
    badge: 'bg-blue-100 text-blue-800 border-blue-200',
    border: 'border-blue-400',
    bg: 'bg-blue-50/50',
  },
  revisi: {
    label: 'Edisi Revisi',
    badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    border: 'border-emerald-400',
    bg: 'bg-emerald-50/50',
  },
  cetakan_baru: {
    label: 'Cetakan Ulang / Baru',
    badge: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    border: 'border-indigo-400',
    bg: 'bg-indigo-50/50',
  },
  digital: {
    label: 'Edisi Digital (E-Book)',
    badge: 'bg-purple-100 text-purple-800 border-purple-200',
    border: 'border-purple-400',
    bg: 'bg-purple-50/50',
  },
  terjemahan: {
    label: 'Edisi Terjemahan',
    badge: 'bg-amber-100 text-amber-800 border-amber-200',
    border: 'border-amber-400',
    bg: 'bg-amber-50/50',
  },
  edisi_khusus: {
    label: 'Edisi Khusus / Kolektor',
    badge: 'bg-rose-100 text-rose-800 border-rose-200',
    border: 'border-rose-400',
    bg: 'bg-rose-50/50',
  },
  edisi_saku: {
    label: 'Edisi Saku (Paperback)',
    badge: 'bg-teal-100 text-teal-800 border-teal-200',
    border: 'border-teal-400',
    bg: 'bg-teal-50/50',
  },
};

export const getEditionTypeInfo = (type?: string | null): EditionTypeStyle => {
  return EDITION_TYPE_STYLES[type || 'orisinal'] || {
    label: type || 'Edisi',
    badge: 'bg-slate-100 text-slate-800 border-slate-200',
    border: 'border-slate-300',
    bg: 'bg-slate-50',
  };
};

export const getStatusBadge = (status: string): React.ReactElement => {
  switch (status) {
    case 'disetujui':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 shrink-0">
          <CheckCircle2 className="w-3 h-3" /> Disetujui
        </span>
      );
    case 'diajukan':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold bg-amber-50 text-amber-700 border border-amber-200 shrink-0">
          <Clock className="w-3 h-3" /> Diajukan
        </span>
      );
    case 'draft':
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold bg-slate-100 text-slate-700 border border-slate-200 shrink-0">
          <BookOpen className="w-3 h-3" /> Draft
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold bg-stone-100 text-stone-700 border border-stone-200 shrink-0">
          <Archive className="w-3 h-3" /> {status}
        </span>
      );
  }
};
